<div class="expedite-container">
  <h2 class="expedite-heading" data-testid="expedite-heading">
    Expedite Request
  </h2>

  <div class="expedite-guidelines" data-testid="expedite-guidelines">
    <p>
      In order to request Expedited processing for your payroll files, please
      read the guidelines listed below.
    </p>

    <ul class="guidelines-list">
      <li>Payroll must be uploaded by 12 noon Customer time.</li>
      <li>
        The fee for Expedited processing is $200.00 per print request. (This fee
        will be invoiced after payroll is processed.)
      </li>
      <li>
        If the payroll is not uploaded by the deadline stated above, we may be
        unable to print and ship your payroll documents in the same day.
      </li>
      <li>
        EXPEDITED processing is on a best effort SLA from UKG, Inc. If your
        request does not make same day printing and shipping the EXPEDITED fee
        will be cancelled.
      </li>
    </ul>

    <p class="agreement-text">
      I have read and agree to the EXPEDITED processing guidelines listed above
      and want this print request to be EXPEDITED.
    </p>
  </div>

  <div class="expedite-options">
    <ukg-button
      type="button"
      size="medium"
      [emphasis]="isExpedited() ? 'high' : 'mid'"
      (click)="selectOption(true)"
      (keydown.enter)="selectOption(true)"
      (keydown.space)="selectOption(true); $event.preventDefault()"
      data-testid="expedite-yes-btn">
      Yes
    </ukg-button>
    <ukg-button
      type="button"
      size="medium"
      [emphasis]="!isExpedited() ? 'high' : 'mid'"
      (click)="selectOption(false)"
      (keydown.enter)="selectOption(false)"
      (keydown.space)="selectOption(false); $event.preventDefault()"
      data-testid="expedite-no-btn">
      No
    </ukg-button>
  </div>
</div>
